import Privacy from './Privacy';
import PrivacyPage from './PrivacyPage';

export { Privacy, PrivacyPage };
